import React from 'react';

const FeatureBanner = ({ featureName, featureDescription, href }) => {
    return (
        <div className="bg-gradient-to-r from-red-400 to-purple-500 py-6 px-4 md:px-8 rounded-xl shadow-md text-white">
            <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-3/4">
                    <h2 className="text-xl md:text-2xl font-bold mb-2">Introducing: {featureName}</h2>
                    <p className="text-md md:text-lg">{featureDescription}</p>
                </div>
                {
                    href && (
                        <div className="md:w-1/2 md:pl-8 mt-4 md:mt-0 flex justify-end">
                            <a
                                href={href}
                                target="_blank"
                                className="bg-white text-purple-600 font-semibold px-6 py-2 rounded inline-block focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                            >
                                Join Waitlist
                            </a>
                        </div>
                    )
                }

            </div>
        </div>
    );
};

export default FeatureBanner;